import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const navItems = [
  { id: 'hero', label: 'Home' },
  { id: 'projects', label: 'Projects' },
  { id: 'skills', label: 'Skills' },
  { id: 'experience', label: 'Experience' },
  { id: 'contact', label: 'Contact' },
];

function scrollToSection(id) {
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export default function GlassNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className="fixed inset-x-0 top-0 z-50 px-4 py-4 sm:px-6 lg:px-10"
    >
      <nav
        className={`mx-auto flex max-w-7xl items-center justify-between rounded-2xl border px-4 py-3 backdrop-blur-xl transition-all sm:px-6 ${
          scrolled
            ? 'border-white/20 bg-slate-950/70 shadow-glow'
            : 'border-white/10 bg-slate-950/45'
        }`}
      >
        <button
          type="button"
          onClick={() => scrollToSection('hero')}
          className="font-display text-sm font-bold uppercase tracking-[0.24em] text-white"
        >
          Prathmesh Bondar
        </button>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => scrollToSection(item.id)}
              className="rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-300 transition hover:bg-white/10 hover:text-white"
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          data-magnetic
          type="button"
          onClick={() => scrollToSection('contact')}
          className="rounded-full bg-neon px-4 py-2 text-xs font-bold uppercase tracking-[0.14em] text-white shadow-glow"
        >
          Hire Me
        </button>
      </nav>
    </motion.header>
  );
}
